module.exports={render:function (){with(this) {
  return _h('div', {
    attrs: {
      "id": "BotAdmin"
    }
  }, [_m(0), " ", _h('table', {
    staticClass: "table"
  }, [_m(1), " ", _h('tbody', [_l((tests), function(test) {
    return _h('tr', [_h('td', [_h('span', [_s(test.regex)])]), " ", _h('td', [_s(test.botMessage.message)]), " ", _h('td', [_l((test.botMessage.prompts), function(prompt) {
      return _h('span', [_s(prompt), _m(2, true)])
    })])])
  })])])])
}},staticRenderFns: [function (){with(this) {
  return _h('div', {
    staticClass: "form-group"
  }, [_h('h1', ["BotAdmin"])])
}},function (){with(this) {
  return _h('thead', [_h('tr', {
    attrs: {
      "align": "left"
    }
  }, [_h('th', ["RegEx"]), " ", _h('th', ["Bot Message"]), " ", _h('th', ["Prompts"])])])
}},function (){with(this) {
  return _h('br')
}}]}


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-loader/lib/template-compiler.js?id=data-v-329aafa7!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/chatbot/BotAdmin.vue
 ** module id = 27
 ** module chunks = 1
 **/